export default ({request}) => ({
  mrpFabricPlanListApi(data = {}) {
    return request({
      url: '/factory/mrp/fabric/plan/list',
      method: 'post',
      data,
    })
  },
  mrpFabricPlanDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/fabric/plan/detail',
      method: 'post',
      data,
    })
  },
  mrpFabricPlanDetailListApi(data = {}) {
    return request({
      url: '/factory/mrp/fabric/plan/detail/list',
      method: 'post',
      data,
    })
  },
  mrpFabricPlanScheduleListApi(data = {}) {
    return request({
      url: '/factory/mrp/fabric/plan/schedule/list',
      method: 'post',
      data,
    })
  },
})
